module.exports = __webpack_public_path__ + "img/Peng_Cui@2x.cbabbea4.png";